<div class="container_dialog">
    <div class="header_popup">
        <div class="title_popup">
            <span>{{"comparator.importing_comparators"| translate}}</span>
        </div>
        <button (click)="close()">
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <form novalidate="" class="display_form ng-untouched ng-pristine ng-invalid">
        <div class="display_block" *ngIf="isUpload">
            <div class="img_block">
                <div class="drop_zone">
                    <span class="inside_block"></span>
                    <span class="text_zone">{{"import.drag_or_click"| translate}}</span>
                </div>
                <input type="file" accept=".xlsx" (change)="onFileChange($event)">
                <div class="image_preview_container"></div>
            </div>
        </div>
        <div class="progress td_inline" *ngIf="!isUpload">
            <img src="assets/icones/xls.svg" alt="">
            <div class="progress_bar">
                <div class="bold_span">{{fileName}}</div>
                <div class="inside_bar">{{sizeOfUpload}} KB</div>
                <div class="td_inline">
                    <mat-progress-bar class="example-margin audio-progress-bar" [mode]="mode" [value]="value"></mat-progress-bar>
                    <span style="text-wrap: nowrap;">{{value}}%</span>
                </div>
            </div>
        </div>
    </form>
    <div class="submet_btns">
        <button class="save_btn_pop_up cancel_btn_pop_up" (click)="close()">
            <span>{{"common.cancel"|translate}}</span>
        </button>
        <button class="save_btn_pop_up blue_btn" (click)="upload()" [disabled]="isUpload">
            <span>{{"common.upload"| translate}}</span>
            <img alt="" src="../../../../../assets/icones/arrow_circle_right.svg">
        </button>
    </div>
</div>
